import { render, staticRenderFns } from "./errPage.vue?vue&type=template&id=b1a546ee&scoped=true"
import script from "./errPage.vue?vue&type=script&lang=js"
export * from "./errPage.vue?vue&type=script&lang=js"
import style0 from "./errPage.vue?vue&type=style&index=0&id=b1a546ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a546ee",
  null
  
)

export default component.exports